<template>
  <div class="word_upload">
    <el-upload
      :data="uploadData"
      :headers="uploadHeaders"
      action="/api/file/addFileByOtherId"
      multiple
      :disabled="readonly"
      :show-file-list="showFile"
      :on-success="handsuccess"
      :before-upload="beforeAvatarUpload"
      :on-progress="uploadProgress"
    > 
  
        <img v-if="imageUrl!=''" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress v-if="progressFlag" :percentage="uploadPercent" :text-inside="true" :stroke-width="20" style="margin-top:20px"></el-progress>
    </el-upload>
 
  </div>
</template>
<!-- 
    *     <wordUpload 
            fileMenuName="议题"
            :id="scope.row.id"
            :plain="false"
            :tip="false"
            :showFile="false" />
    *    
    *     fileMenuName  :附件名称 (String)  
          id:            id (Number)
    *     plain: 按钮样式  (Boolean)
    *     tip：   提示  (Boolean)
    *     showFile： 是否显示已上传文件列表  (Boolean)
    *     index:  第几条，针对列表  (Boolean)
    *
    *
    *
    *
   -->
<script>
import Cookies from "js-cookie";
import * as api from "@/api/meeting/meetingcategory";
import * as dictionaries from "@/api/zd/dictionaries";
export default {
  name: "wordUpload",
  data() {
    return {
      baFileMenuId: "",
      progressFlag: false,
      uploadPercent: 0,
    };
  },
  computed: {
    uploadHeaders() {
      return {
        "Blade-Auth": "bearer " + Cookies.get("saber-access-token"),
      };
    },
    uploadData() {
      return {
        fileOtherId: this.id,
        baFileMenuId: this.baFileMenuId,
      };
    },
  },
  watch:{
    id:{
      deep:true,
      handler(val){
        if(val){
             this.getFileMenuByName(this.fileMenuName);
        }
         
      }
    }
  },
  props: {
    id: {
      type: Number,
      default: -1,
    },
    index: {
      type: Number,
      default: -1,
    },
    fileMenuName: {
      type: String,
      default: '',
    },
    baFileMenuId: {
      type: Number,
      default: -1,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: Boolean,
      default: false,
    },
    showFile: {
      type: Boolean,
      default: false,
      
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    imageUrl:{
          type: String,
      default: '',
    }
  },
  
  created() {
    if(this.fileMenuName&&this.id){
      this.getFileMenuByName(this.fileMenuName);
    }
    
  },
  methods: {
  
    //通过名称获取菜单
    getFileMenuByName(fileMenuName) {
      
      dictionaries
        .getFileMenuByName({ fileMenuName })
        .then((res) => {
          this.baFileMenuId = res.data.data.id;
          this.getimages()
        })
        .catch((res) => {
          // console.log(res);
        });
    },
     getimages() {
      dictionaries
        .findFileByOtherId({
          fileOtherId: this.id,
          baFileMenuId:  this.baFileMenuId ,
        })
        .then((res) => {
          // console.log(res.data.data);
          this.$emit('getimages',res.data.data) 
          // this.form[name + "Id"] = res.data.data;
        })
        .catch((res) => {});
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadProgress(event, file, fileList) {
      this.progressFlag = true;
      this.uploadPercent = Math.floor(event.percent);
      },
          handsuccess(file, fileList) {
            
            this.$message({
              type: "success",
              message: "上传成功!",
            });
            this.progressFlag = false;
      this.uploadPercent = 0;
      api
        .findFileByOtherId({ fileOtherId:this.id,baFileMenuId:this.baFileMenuId})
        .then((res) => {
           
           this.$emit("showFileName",res.data.data,this.index)
         
        })
        .catch((res) => {
          this.loading=false
          
        });

    },
    
    beforeAvatarUpload(file) {
      
      const isJPG = file.type.indexOf("image")>-1;
      // const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error("上传文件只能是图片格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      return isJPG ;
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },

    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // }
  },
};
</script>

<style lang="scss" scoped>
.file_button {
  width: 400px !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px;
  height: 124px;
  border-radius: 5px;
  line-height: 124px;
  text-align: center;
  border: 1px solid #d9d9d9d9;
}
.avatar {
  width: 96px;
  height: 124px;
  display: block;
  border-radius: 5px;
}
</style>
